module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWXTips),
      expression: "showWXTips"
    }],
    staticClass: "wx-tips-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/wx_tips.jpg")
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e765dde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage/wxTips.vue
// module id = 304
// module chunks = 0 1 2 3